import { IAcquisitionOverview } from "../types/acquisition-overview";

export const initialAcquisitionOverview: IAcquisitionOverview = {
    reason: 0,
    explication: "",
    acquisiton_type: 0,
    transaction_duration: 0,
    business_value: 0
};